import { useWallet } from '@solana/wallet-adapter-react'
import classNames from 'classnames'

import { Loader } from '@banx/components/Loader'
import { Tabs, useTabs } from '@banx/components/Tabs'

import { AdventuresList, Header, HistoryAdventuresList, Sidebar } from './components'
import { useBanxStakeInfo } from './hooks'

import styles from './AdventuresPage.module.less'

export const AdventuresPage = () => {
  const { connected } = useWallet()
  const { banxStakeInfo, isLoading } = useBanxStakeInfo()

  const { value: currentTab, ...tabProps } = useTabs({
    tabs: TABS,
    defaultValue: AdventureTab.Adventures,
  })

  const isDataReady = !!banxStakeInfo
  const sidebarVisible = connected && isDataReady

  const listClassNames = classNames(styles.adventuresList, {
    [styles.adventuresListSidebarVisible]: sidebarVisible,
  })

  return (
    <div className={styles.pageWrapper}>
      <div className={styles.content}>
        <Header />
        <Tabs value={currentTab} type="secondary" {...tabProps} />

        {isLoading && <Loader className={styles.loader} />}

        {isDataReady &&
          (currentTab === AdventureTab.Adventures ? (
            <AdventuresList banxStakeInfo={banxStakeInfo} className={listClassNames} />
          ) : (
            <HistoryAdventuresList banxStakeInfo={banxStakeInfo} className={listClassNames} />
          ))}
      </div>

      {sidebarVisible && <Sidebar banxStakeInfo={banxStakeInfo} className={styles.sidebar} />}
    </div>
  )
}

enum AdventureTab {
  Adventures = 'adventures',
  History = 'history',
}

const TABS = [
  {
    label: 'Adventures',
    value: AdventureTab.Adventures,
  },
  {
    label: 'History',
    value: AdventureTab.History,
  },
]
